module.exports = __webpack_public_path__ + "img/xw.43d6654f.gif";